import React from "react";
import "./Template_1.css";

const Template_1_Header = () => {
  return (
    <header className="Template_1 header-template-1">
      <div className="Template_1container">
        <div className="Template_1 header-content">
          <div className="Template_1 logo">
            <i className="fas fa-globe-americas"></i>
            TravelEase
          </div>
          <nav>
            <ul>
              <li>
                <a href="/template_1_homepage">Home</a>
              </li>
              <li>
                <a href="#">Packages</a>
              </li>
              <li>
                <a href="#">Destinations</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#reviews">Reviews</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Template_1_Header;
